import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Container, FloatingLabel, Form, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Column, DateTimePicker, Icon, Label, Panel, Select } from "../../../components";
import { SelectOption } from '../../../shared/components/input/SelectOption';
import './Customer-Policy-Action.scss';
import CustomerPolicyActionService from "./CustomerPolicyActionService";
import { RootState } from "../../../shared/store";
import Logger from "../../../shared/services/Logger";
import DatePicker from "react-datepicker";
import { CommonUtility } from "../../../Services/CommonUtility";
import { PolicyDto } from "../../model/PolicyDto";
import { PolicyEventDto } from "../../model/PolicyEventDto";
import CustomerInsuredName from "../../model/CustomerInsuredName";
import LookupService from "../../../Services/LookupService";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import * as constant from '../../../shared/util/constant';
import * as labelconstant from '../../../shared/util/label';
import { toast } from "react-toastify";
import { PolicyTransactionPremiumDto } from "../../model/PolicyTransactionPremiumDto";
import { useHistory, useLocation } from "react-router-dom";
import { PolicyTransactionsReadDto } from "../../model/PolicyTransactionsReadDto";
import { PolicyDtoRead } from "../../model/PolicyDtoRead";
import { storeCustomerPolicies } from "../../customer-slice/Customer-slice";
import { PolicyLOBReadDto } from "../../model/PolicyLOBReadDto";
import { uuid } from "../../../shared/util/uuid";
import CustomerPolicyListService from "../CustomerPolicyListService";
import CustomerPolicyDetailViewService from "../customer-policy-detail-view/CustomerPolicyDetailViewService";
import { SliderDataAction, updateSliderData } from "../../customer-slider-content/CustomerSliderContext";
import CustomerActivityService from "../../customer-activity/CustomerActivityService";

export interface ICustomerPolicyAction {
    selectedTransaction: string;
    defaultPolicyDto: PolicyDto;   
    selectedAction: string;
    onCloseModal: () => void;
}

interface ICustomerPolicyActionComponentState {
             id: string,
             custId:string,
             policyNumber: string,
             insured: boolean,
             coInsured: boolean,
             fromEffectiveDate: Date,
             toEffectiveDate: Date,
             selectedTransactionType: string,
             transactionDescription: string,
             selectedTypeOfBusiness: string,
             selectedState: string,
             selectedLineOfBusiness: string,
             selectedFormTypeId: string,
             selectedSource: string,
             selectedSourceId: string,    
             selectedCompanyId:string, 
             selectedWritingCompanyId:string,
             selectedPolicyTypeId:string,
             fullTermPremium: string,
             policyTypeId:string,
}

const CustomerNewPolicy: React.FunctionComponent<ICustomerPolicyAction> = (props) => {
         
        const {selectedTransaction, defaultPolicyDto, selectedAction, onCloseModal } = props;
        const dispatch = useDispatch();
        const history = useHistory();
        const transactionTypeData = useSelector((state: RootState) => state?.LookupState.transactionTypeList);
         const lineOfbusinessData = useSelector((state: RootState) => state?.LookupState.lineOfBusinessList);
         const sourceTypeData = useSelector((state: RootState) => state?.LookupState.sourceTypeList);
         const stateUSData = useSelector((state: RootState) => state?.LookupState.stateUSList);        
         const policyBusinessTypeData = useSelector((state: RootState) => state?.LookupState.policyBusinessTypeList);
         const sourceTypeLookupValueData = useSelector((state: RootState) => state?.LookupState.sourceTypeLookupValue);
        const parentCompanyListData = useSelector((state: RootState) => state?.LookupState.parentCompaniesList); // only need parent companies over here
        const writingCompanyData = useSelector((state: RootState) => state?.LookupState.writingCompaniesList);
        const customerSummary = useSelector((state: RootState) => state?.customerSlice.customerSummary);
        const policyTypeData = useSelector((state: RootState) => state?.LookupState.policyTypeList);
        const formTypeData = useSelector((state: RootState) => state?.LookupState.formTypeList);

     const policyActionService = new CustomerPolicyActionService();

    const customerActivityService = new CustomerActivityService();
     
     let newPolicyComponentInitData: ICustomerPolicyActionComponentState = {
        id: defaultPolicyDto.id || '',
        custId:defaultPolicyDto.custId || '',
        policyNumber: defaultPolicyDto.policyNumber || '',
        insured: true,
        coInsured: true,
        fromEffectiveDate: defaultPolicyDto.polEffDate,
        toEffectiveDate: defaultPolicyDto.polExpDate,
        selectedTransactionType: selectedTransaction ||'',
        transactionDescription: '',
        selectedTypeOfBusiness: defaultPolicyDto.typeOfBusId || '',
        selectedState: defaultPolicyDto.issuedState || '',
        selectedLineOfBusiness: defaultPolicyDto.polTypeLobId || '',
        selectedFormTypeId: defaultPolicyDto.formTypeId || '',
        selectedSource: defaultPolicyDto.sourceTypeId || '',
        selectedSourceId: defaultPolicyDto.sourceId || '',
        selectedCompanyId: defaultPolicyDto.companyId || '',
        selectedWritingCompanyId: defaultPolicyDto.writingCompanyId || '',
        selectedPolicyTypeId: defaultPolicyDto.policyTypeId || '',
        fullTermPremium: defaultPolicyDto.fullTermPremium?.toString() || '',
        policyTypeId:defaultPolicyDto.policyTypeId || ''
        
     }

    const [newPolicyComponentData, setNewPolicyComponentData]  = useState<ICustomerPolicyActionComponentState>(newPolicyComponentInitData);       
    const [policyNumber, setPolicyNumber] = useState<string>('');
    const [transactionTypes, setTransactionTypes] = useState<SelectOption[]>([]);
    const [typeOfBusiness, setTypeOfBusiness] = useState<SelectOption[]>([]);
    const [issueStates, setIssueStates] = useState<SelectOption[]>([]);
    const [lineOfbusiness, setLineOfbusiness] = useState<SelectOption[]>([]);    
    const [source, setSource] = useState<SelectOption[]>([]);
    const [sourceId, setSourceId] = useState<SelectOption[]>([]);
    const [parentCompanyList, setParentCompanyList] = useState<SelectOption[]>([]);
    const [writingCompanyList, setWritingCompanyList] = useState<SelectOption[]>([]);
    const [policyTypeList, setPolicyTypeList] = useState<SelectOption[]>([]);
    const [formTypeList, setFormTypeList] = useState<SelectOption[]>([]);
    const [formValidation, setFormValidation] = useState<any>({});
    const [priorPolicyId, setPriorPolicyId] = useState<string>(defaultPolicyDto.priorPolicyId);
    const policies = useSelector((state: RootState) => state?.customerSlice.policies);
    const companiesList = useSelector((state: RootState) => state?.LookupState.companyList);
    const [filteredWritingCompanies, setFilteredWritingCompanies] = useState<SelectOption[]>(writingCompanyList);

    // Refs for Shift+Tab focus cycling
    const insuredCheckboxRef = useRef<any>(null);
    const submitButtonRef = useRef<any>(null);

    // Set focus on Insured checkbox when modal opens
    useEffect(() => {
        insuredCheckboxRef.current?.focus();
    }, []);

    const toggleEntityField = (propName: string) => {     

          setNewPolicyComponentData((prevState) => ({
          ...prevState,
          [propName]: !prevState[propName], // Toggle the current value
      }));
    }

  const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {   
      if(propName === "policyNumber")
        {
            setPolicyNumber(value.toString());
        }  

        // Automatically set `toEffectiveDate` to 1 year later when `fromEffectiveDate` is updated
        if (propName === "fromEffectiveDate" && value instanceof Date) {           
            const oneYearLater = new Date(value);
            oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

            setNewPolicyComponentData((prevState) => ({
                ...prevState,
                [propName]: value,
                toEffectiveDate: oneYearLater, // Update `toEffectiveDate`
            }));
            return;
        }
       setNewPolicyComponentData((prevState) => ({
          ...prevState,
            [propName]: value,
        }));
      }

          const handleParentCompanyChange = async(value: string | null) => {
              if (!value) {
                  // If parent company is deselected, do not show any writing companies
                  setFilteredWritingCompanies([]);
              } else {
                  // Filter writing companies based on selected parent company
                  const filteredCompanies = companiesList
                      .filter(company => company.parentId === value && company.parentId !== company.value)
                      .map(company => ({
                            ...company,
                            label: CommonUtility.capitalizeFirstCharOfEachWord(company.label)
                        }));
                  
                  // If no companies found for the parent, do not show any writing companies
                  setFilteredWritingCompanies(filteredCompanies.length > 0 ? filteredCompanies : []);
              }
      
              // Update parent company and reset writing company
            setNewPolicyComponentData((prevState) => ({
                ...prevState,
                  ["selectedCompanyId"]: value || null,
                  ["selectedWritingCompanyId"]: null
                }));
          };
      
          const handleWritingCompanyChange = (value: string | null) => {
              if (!value) {
                setNewPolicyComponentData((prevState) => ({
                    ...prevState,
                    ["selectedWritingCompanyId"]: null
                    }));
      
                  // If parent company is selected, show filtered list, otherwise show none
                  if (newPolicyComponentData.selectedCompanyId) {
                      const filteredCompanies = companiesList
                          .filter(company => company.parentId === newPolicyComponentData.selectedCompanyId && company.parentId !== company.value)
                          .map(company => ({
                                ...company,
                                label: CommonUtility.capitalizeFirstCharOfEachWord(company.label)
                            }));
                    // If no companies found for the parent, do not show any writing companies
                    setFilteredWritingCompanies(filteredCompanies.length > 0 ? filteredCompanies : []);
                  } else {
                      setFilteredWritingCompanies([]);
                  }
              } else {
                  // Find the selected writing company
                  const selectedCompany = companiesList.find(company => company.value === value && company.value != company.parentId);
                  
                  if (selectedCompany) {
                      // Update writing company
                    setNewPolicyComponentData((prevState) => ({
                        ...prevState,
                        ["selectedWritingCompanyId"]: value
                        }));
                  }
              }
          };

      useEffect(() => {
            initializeComponent();
        }, []);

        // Set initial filtered writing companies based on selected parent company
        useEffect(() => {
            if (newPolicyComponentData?.selectedCompanyId && companiesList.length > 0) {
                const filteredCompanies = companiesList
                    .filter(company => company.parentId === newPolicyComponentData.selectedCompanyId && company.parentId !== company.value)
                    .map(company => ({
                            ...company,
                            label: CommonUtility.capitalizeFirstCharOfEachWord(company.label)
                        }));
                setFilteredWritingCompanies(filteredCompanies);
            }
        }, [newPolicyComponentData?.selectedCompanyId, companiesList]);

        // Update selectedPolicyTypeId from prior policy when it becomes available
        useEffect(() => {
            console.log(defaultPolicyDto.policyTypeId)
            if (defaultPolicyDto.policyTypeId && !newPolicyComponentData.selectedPolicyTypeId) {
                setNewPolicyComponentData((prevState) => ({
                    ...prevState,
                    selectedPolicyTypeId: defaultPolicyDto.policyTypeId || '',
                }));
            }
        }, [defaultPolicyDto.policyTypeId]);


    const dispatchAllLookup = (lookupData) => {
            dispatch(updateLookupData({ data: lookupData.transactionTypeLookup, type: constant.SlicerLookUpConstant.Transaction_Type }));
            dispatch(updateLookupData({ data: lookupData.businessTypeLookup, type: constant.SlicerLookUpConstant.POLICY_BUSINESS_TYPE }));
            dispatch(updateLookupData({ data: lookupData.usStatesLookup, type: constant.SlicerLookUpConstant.US_STATE }));
            dispatch(updateLookupData({ data: lookupData.lineOfBusinessLookup, type: constant.SlicerLookUpConstant.Line_Of_Business }));
            dispatch(updateLookupData({ data: lookupData.sourceTypesLookup, type: constant.SlicerLookUpConstant.Source_Type }));
            dispatch(updateLookupData({ data: lookupData.parentCompanyListLookup, type: constant.SlicerLookUpConstant.PARENT_COMPANIES }));
            dispatch(updateLookupData({ data: lookupData.writingCompaniesLookup, type: constant.SlicerLookUpConstant.WRITING_COMPANIES }));
            dispatch(updateLookupData({ data: lookupData.companyListLookup, type: constant.SlicerLookUpConstant.COMPANY_LIST }));
            dispatch(updateLookupData({ data: lookupData.policyTypeLookup, type: constant.SlicerLookUpConstant.POLICY_TYPE }));
            dispatch(updateLookupData({ data: lookupData.formTypeLookup, type: constant.SlicerLookUpConstant.FORM_TYPE }));
        };

    let initializeComponent = async ()  => {   
        let lookupData = {
                transactionTypeLookup: [], businessTypeLookup: [], usStatesLookup: [], lineOfBusinessLookup: [], sourceTypesLookup: [], parentCompanyListLookup: [],
            writingCompaniesLookup: [], companyListLookup: [], policyTypeLookup: [], formTypeLookup: []
            };

            if (transactionTypeData.length === 0 ||
                lineOfbusinessData.length === 0 || sourceTypeData.length === 0 || parentCompanyListData.length === 0 || 
                policyBusinessTypeData.length === 0 || stateUSData.length == 0 || writingCompanyData.length === 0 || companiesList.length === 0 || policyTypeData.length === 0 || formTypeData.length === 0) {
                lookupData = await policyActionService.fetchDropDownData();
                dispatchAllLookup(lookupData)
            }
            else {
                lookupData = {
                    transactionTypeLookup: [...transactionTypeData], businessTypeLookup: [...policyBusinessTypeData],
                    usStatesLookup: [...stateUSData], lineOfBusinessLookup: [...lineOfbusinessData], sourceTypesLookup: [...sourceTypeData],
                    parentCompanyListLookup: [...parentCompanyListData], writingCompaniesLookup: [...writingCompanyData], companyListLookup: [...companiesList],
                    policyTypeLookup: [...policyTypeData], formTypeLookup: [...formTypeData]
                };
            }         
           
           const disabledLabels = (constant.disabledTransactionsByAction[selectedAction] || []).map(l => l.toLowerCase());
           const allowedLabels = (constant.allowedTransactionsByAction[selectedAction] || []).map(l => l.toLowerCase());
           setTransactionTypes(
                lookupData.transactionTypeLookup.map((type: SelectOption) => {
                    const lowerLabel = type.label.toLowerCase();
                    const isDisabled = disabledLabels.includes(lowerLabel);
                    return {
                        ...type,
                        label: CommonUtility.capitalizeFirstCharOfEachWord(type.label),
                        disabled: isDisabled,
                        isWarning: !isDisabled && !allowedLabels.includes(lowerLabel),
                    };
                })
            );
            setTypeOfBusiness(lookupData.businessTypeLookup);
            setIssueStates(lookupData.usStatesLookup);
            setLineOfbusiness(lookupData.lineOfBusinessLookup);           
            setSource(lookupData.sourceTypesLookup);   
            setParentCompanyList(
                lookupData.parentCompanyListLookup.map((type: SelectOption) => ({
                    ...type,
                    label: CommonUtility.capitalizeFirstCharOfEachWord(type.label),
                }))
            );
            setWritingCompanyList(
                lookupData.writingCompaniesLookup.map((type: SelectOption) => ({
                    ...type,
                    label: CommonUtility.capitalizeFirstCharOfEachWord(type.label),
                }))
            );
            setPolicyTypeList(lookupData.policyTypeLookup);
            setFormTypeList(lookupData.formTypeLookup);
            if(newPolicyComponentData.selectedSource !== '')          
            {
               await handleSourceTypeChange(newPolicyComponentData.selectedSource);
               setNewPolicyComponentData((prevState) => ({
                ...prevState,
                    ["selectedSourceId"]: defaultPolicyDto.sourceId
                })); 
            }
    }

     const handleSourceTypeChange = async(value: string) => {
         await  fetchSourceTypeLookupValue(value);  
         setNewPolicyComponentData((prevState) => ({
          ...prevState,
            ["selectedSource"]: value
        })); 
    };

    useEffect(() => {
        // Only set default source for New policies, not for Renew/Rewrite
        if (source.length > 0 && !newPolicyComponentData.selectedSource) {
            setNewPolicyComponentData((prevState) => ({
                ...prevState,
                ["selectedSource"]: constant.DEFAULT_SOURCE_ID
            }));
            handleSourceTypeChange(constant.DEFAULT_SOURCE_ID);
        }
    }, [source]);

    const fetchSourceTypeLookupValue = async (sourceTypeId: string) => {
        // Preserve existing selectedSourceId before fetching
        const existingSourceId = newPolicyComponentData.selectedSourceId;        
        try {
             // Retrieve the specific lookup value using the sourceTypeId
            let sourceTypeLookupValue = sourceTypeLookupValueData?.[sourceTypeId];           
            if(sourceTypeLookupValue === null || sourceTypeLookupValue === undefined)
            {
              sourceTypeLookupValue = await policyActionService.getSourceTypeLookupValue(sourceTypeId);
            }
            if (sourceTypeLookupValue) {
                // Dispatch sourceTypeLookupValue to the Redux store
                dispatch(
                    updateLookupData({
                        data: {
                            sourceTypeId: sourceTypeId,
                            sourceTypeLookupValue: sourceTypeLookupValue,
                        },
                        type: constant.SlicerLookUpConstant.Source_Type_Lookup_Value,
                    })
                );
                const sourceList = await policyActionService.getSourceList(sourceTypeLookupValue.lookupCode);
                setSourceId(sourceList || []); // Set local state                    
            } else {
                Logger.logError("No source type found for ID:", sourceTypeId);
                setSourceId([]);                 
            }
        } catch (error) {
            Logger.logError("Error fetching source type lookup value:", error);
            setSourceId([]);            
        }

        // Only reset selectedSourceId to null if there is no existing value to preserve for Renew/Rewrite.
        if (!existingSourceId) {
            setNewPolicyComponentData((prevState) => ({
                  ...prevState,
                    ["selectedSourceId"]: null
                })); 
        }
    };

    const handleSavePolicy = async (data: any) => {  

        let tranType= '';
        let transNote = '';
        let premium: number | undefined = undefined;
        let subTranType ='';

        try{
         switch (selectedAction) {
                    case constant.policyActionConstant.NEW:
                        tranType = constant.EventTransactionType.NBS;
                        transNote = constant.EventTransactionNote.NBS_NEW_POLICY;
                        break;
                    case constant.policyActionConstant.REWRITE:    
                        tranType = constant.EventTransactionType.REW;
                        transNote = constant.EventTransactionNote.REW;
                        break;
                    case constant.policyActionConstant.RENEW: 
                        tranType = constant.EventTransactionType.RWL;
                        transNote = constant.EventTransactionNote.RWL;
                        break;
                    default:
                       return
                        
                }

                // assign selected tranType with dropdown selection if available
                    if (data.selectedTransactionType && data.selectedTransactionType.trim().length > 0) {
                        subTranType = data.selectedTransactionType;
                    }

        premium = data.fullTermPremium?.trim() ? Number(data.fullTermPremium) : undefined;
        transNote = data.transactionDescription?.trim() || transNote;
                
        const existingInsureds = defaultPolicyDto.policyInsureds || [];
        const existingCoInsureds = defaultPolicyDto.policyCoInsureds || [];
        const existingPreviousAddress = defaultPolicyDto.policyPreviousAddress || [];                
        const existingLOBs = defaultPolicyDto.policyLineOfBusinesses || [];
        const polEventId = defaultPolicyDto.policyEvents && defaultPolicyDto.policyEvents.length > 0 ? defaultPolicyDto.policyEvents[defaultPolicyDto.policyEvents.length - 1].id : uuid();
        const updatedPolicyEvents = (defaultPolicyDto.policyEvents || []).map(event => {
            // Find if any LOB is tied to this event
            const lobForEvent = (defaultPolicyDto.policyLineOfBusinesses || []).find(lob => lob.polEventId === event.id);
            if (lobForEvent) {
                // Update event fields as needed
                return {
                    ...event,
                    tranType: data.selectedTransactionType,
                    tranNote: transNote,
                    carrierTransactionEnteredDate: new Date().toISOString(),
                    tranEffDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                };
            }
            return event;
        });

            let policyEvents: PolicyEventDto[] = [];
            if (defaultPolicyDto.policyEvents && defaultPolicyDto.policyEvents.length > 0) {
                policyEvents = updatedPolicyEvents; // as above
            } else {
                // Create a new event
                policyEvents = [{
                    polId: defaultPolicyDto.id,
                    tranType: data.selectedTransactionType,
                    tranNote: transNote,
                    carrierTransactionEnteredDate: new Date().toISOString(),
                    tranEffDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                    }];
            }

            const policyTransactionPremium: PolicyTransactionPremiumDto[] = [{
                premium: premium,
                effDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
            }];

            let updatedLOBs = [...existingLOBs];
            const lobIndex = updatedLOBs.findIndex(lob => lob.lobCodeId === data.selectedLineOfBusiness);

            if (lobIndex !== -1) {
                // Update existing LOB's effDate and expDate
                updatedLOBs[lobIndex] = {
                    ...updatedLOBs[lobIndex],
                    formTypeId: data.selectedFormTypeId,
                    effDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                    expDate: data.toEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.toEffectiveDate) : null,
                };
            } else {
                // Only add a new LOB if not found (for NEW, not Renew/Rewrite)
                updatedLOBs.push({
                    id: constant.DEFAULT_GUID,
                    polId : defaultPolicyDto.id,
                    polEventId: polEventId,
                    lobCode: "",
                    lobCodeId: data.selectedLineOfBusiness,
                    formTypeId: data.selectedFormTypeId,
                    effDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                    expDate: data.toEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.toEffectiveDate) : null,
                    policyCoverages: [],
                    policyAdditionalInterests: [],
                    policyLocations: [],
                });
            }

            const policyDto: PolicyDto = {
                id: defaultPolicyDto.id,             
                policyNumber: data.policyNumber,
                custId: data.custId,
                polEffDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                polExpDate: data.toEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.toEffectiveDate) : null,
                sourceId: data.selectedSourceId,
                sourceTypeId: data.selectedSource,
                typeOfBusId: data.selectedTypeOfBusiness,
                polTypeLobId: data.selectedLineOfBusiness,
                issuedState: data.selectedState,
                inceptionDate: data.ininceptionDate,
                priorPolicyId: defaultPolicyDto.priorPolicyId,
                companyId: data.selectedCompanyId,
                writingCompanyId: data.selectedWritingCompanyId,
                policyTypeId: data.selectedPolicyTypeId,
                formTypeId: data.selectedFormTypeId,
                fullTermPremium: premium,
                policyEvents: policyEvents,
                policyTransactionPremiums: policyTransactionPremium,
                policyLineOfBusinesses: updatedLOBs,
                policyInsureds: (() => {
                    if (selectedAction === constant.policyActionConstant.NEW) {
                        if (data.insured && customerSummary) {
                            const insuredFromCustomer: CustomerInsuredName = {
                                id: uuid(),
                                polId: defaultPolicyDto.id,
                                polEventId: polEventId,
                                effDate: new Date(),
                                firstName: customerSummary.firstName,
                                lastName: customerSummary.lastName,
                                midName: customerSummary.midName,
                                homePhone: customerSummary.homePhone,
                                workPhone: customerSummary.workPhone,
                                mobile: customerSummary.mobile,
                                eMail: customerSummary.eMail,
                                resAddr1: customerSummary.address1,
                                resAddr2: customerSummary.address2,
                                resCity: customerSummary.city,
                                resState: customerSummary.state,
                                resZip: customerSummary.zipCode,
                                otherPhone1: customerSummary.otherPhone1,
                                otherPhone2: customerSummary.otherPhone2,
                                email2: customerSummary.eMail2,
                                email3: customerSummary.email3,
                                decNameApp: customerSummary.displayName,
                            };
                            return [insuredFromCustomer];
                        }
                        return [];
                    }
                    return data.insured ? [...existingInsureds] : [];
                })(),
                policyCoInsureds: selectedAction === constant.policyActionConstant.NEW ? [] : (data.coInsured ? [...existingCoInsureds] : []),
                policyExt: { subTranType: subTranType }
            }

            let validationError = policyActionService.validatePolicyAction(policyDto);
            if ((!newPolicyComponentData.selectedTransactionType) || newPolicyComponentData.selectedTransactionType.trim().length == 0) {
                validationError['transactionDD'] = { isValid: false, warningText: constant.policyActionSummaryConstant.Customer_Policy_Action_MANDATORY };
            }
            
            // Checking for policy duplicate terms on RENEW
            if (selectedAction === constant.policyActionConstant.RENEW) {
                const { isDuplicate, errorText } = policyActionService.checkDuplicateTerm(
                    data.policyNumber,
                    policies,
                    data.fromEffectiveDate,
                    data.toEffectiveDate
                );
                if (isDuplicate) {
                    validationError['fromEffectiveDate'] = { isValid: false, warningText: errorText };
                    validationError['toEffectiveDate'] = { isValid: false, warningText: errorText };
                }
            }
            
            setFormValidation(validationError);
            if (Object.keys(validationError).length > 0) {
            toast.warn(constant.CUSTOMER_FORM_VALIDATION_ERROR_MESSAGE, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
            }
           let response = await policyActionService.savePolicyTransaction(tranType, policyDto);          
            const customerPolicyListService  = new CustomerPolicyListService();                  
            const updatedPolicies = await customerPolicyListService.fetchCustomerPolicyDetails(data.custId); 
            let updatePolicyList = await customerActivityService.getPoliciesForCustomer(data.custId);
             
            dispatch(storeCustomerPolicies(updatedPolicies));     
            dispatch(updateSliderData({ type: SliderDataAction.ActivityPolicyListUpdate, data: updatePolicyList }));
            dispatch(updateSliderData({ type: SliderDataAction.TaskPolicyListUpdate, data: updatePolicyList }));
            
             
         
            const customerPolicyDetailViewService = new CustomerPolicyDetailViewService();
            let responseTransactionDetails = await customerPolicyDetailViewService.getTransactionsDetails(response?.policy?.id);  
            onCloseModal();
            history.push(`/customer-view/policy-details/${data.custId}/${response?.policy?.id}/${responseTransactionDetails[responseTransactionDetails.length -1]?.polEventId}`, { policyTransactionClicked:responseTransactionDetails[responseTransactionDetails.length -1], policyId:response?.policy?.id});  
            
        }
            catch (error) {
                Logger.logError(error.toString()); 
                toast.error(labelconstant.PolicyActionLabels.ERROR_MESSAGE, {
                position: toast.POSITION.TOP_RIGHT,
                });               
            }    
         
     }

    return (
        <>
        <Container fluid className="mt-4">
            <Row style={{ display: 'flex' }}>
                <Column style={{flex: '0 0 65%'}}>
                 <Row>                  
                  <Label className='inlineLable mb-3' text='IMPORT RECORDS' />            
                </Row>
                <Row>
                <Column lg={6}>
                

                                                                                       

                                                                                                                <Form.Check
                                                                                              id="Insured"
                                                                                              label={" Insured"}
                                                                                              checked={newPolicyComponentData.insured}
                                                                                              onChange={() => toggleEntityField('insured')}
                                                                                              className="mb-3 custom-checkbox"
                                                                                              tabIndex={1}
                                                                                              ref={insuredCheckboxRef}
                                                                                              onKeyDown={(e) => {
                                                                                                  if (e.key == "Tab" && e.shiftKey) {
                                                                                                      submitButtonRef.current?.focus();
                                                                                                      e.preventDefault();
                                                                                                  }
                                                                                              }}
                                                                                          />

                                                                                          
                </Column>
                {selectedAction !== constant.policyActionConstant.NEW && (
                <Column lg={6} md={6}>
                
                                      <Form.Check
                                                                                              id="CoInsured"
                                                                                              label={"Co-Insured"}
                                                                                              checked={newPolicyComponentData.coInsured}
                                                                                              onChange={() => toggleEntityField('coInsured')}
                                                                                              className="mb-3 custom-checkbox"
                                                                                              tabIndex={2}
                                                                                          />
                </Column>
                )}
                </Row>
                 <Row>
                     <h6 className='mt-2 me-2 mb-3'>BASIC POLICY INFORMATION</h6>
                 </Row>
                 <Row>
                  <Column lg={4}>
                                    <FloatingLabel
                                        controlId="policyNumberTxt"
                                        label={
                                            <>
                                                {labelconstant.PolicyActionLabels.POLICY_NUMBER}
                                                <span className="text-danger">*</span>
                                            </>
                                        }>                                        
                                        <Form.Control
                                            type="text"
                                            name="policyNumber"
                                            placeholder={labelconstant.PolicyActionLabels.POLICY_NUMBER}
                                            value={newPolicyComponentData.policyNumber || ""}
                                            onChange={(event) => onEntityFieldChange('policyNumber', event.currentTarget.value)}
                                            disabled={false} // Set to true if the field should be non-editable
                                            maxLength={300}
                                            width={200}
                                            required={true}
                                            isInvalid={formValidation['policyNumber']?.isValid == false}
                                            tabIndex={3}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['policyNumber']?.warningText}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                
                            </Column>
                   
                          <Column lg={4}>
                       <Select
                                                                    id="lobDD"
                                                                    controlId="lobDD"
                                                                    className='mb-3'
                                                                    label={<>{labelconstant.PolicyActionLabels.LINE_OF_BUSINESS}<span className="text-danger ms-1">*</span></>}
                                                                    options={lineOfbusiness}
                                                                    defaultSelected={lineOfbusiness.filter(option =>
                                                                          option.value === newPolicyComponentData.selectedLineOfBusiness
                                                                      )}
                                                                    onChange={(values) => onEntityFieldChange('selectedLineOfBusiness', values[0] as string)}
                                                                    disabled={false}
                                                                    
                                                                    tabIndex={4}
                                                                    isInvalid={formValidation['lobDD']?.isValid == false}
                                                                    invalidWarning={formValidation['lobDD']?.warningText}
                                                                />
                    </Column>
                    <Column lg={4}>
                       <Select
                            id='formTypeId'
                            controlId="formTypeId"
                            className='mb-3'
                            label={<>{labelconstant.PolicyActionLabels.FORM_TYPE}<span className="text-danger ms-1">*</span></>}
                            options={formTypeList}
                            defaultSelected={formTypeList?.filter(({ value }) =>
                                    value === newPolicyComponentData?.selectedFormTypeId
                                )}
                            onChange={(values) => {
                                onEntityFieldChange('selectedFormTypeId', values[0] as string)
                            }}
                            placeholder={constant.PLEASE_SELECT}
                            multiple={false}
                            disabled={false}
                            tabIndex={5}
                            showAsFloatingLabel={true}
                            isInvalid={formValidation['formTypeId']?.isValid == false}
                            invalidWarning={formValidation['formTypeId']?.warningText}
                        />
                    </Column>
                 </Row>
                 <Row>
                     

                                                <InputGroup className={`mb-3 ${formValidation['fromEffectiveDate']?.isValid === false ? 'is-invalid' : ''}`}>
                                                                            <InputGroup.Text>
                                                                                {labelconstant.PolicyActionLabels.EFFECTIVE_DATE}
                                                                            </InputGroup.Text>
                                                                            <DatePicker
                                                                                dateFormatCalendar="LLLL yyyy"
                                                                                dropdownMode="scroll"                                                                                
                                                                                selected={CommonUtility.datetimeToDateOnlyObject(newPolicyComponentData.fromEffectiveDate)}
                                                                                onChange={(date) => onEntityFieldChange('fromEffectiveDate', date)}
                                                                                className={`form-control ${formValidation['fromEffectiveDate']?.isValid === false ? 'is-invalid' : ''}`}
                                                                                isRequired={true}
                                                                                tabIndex={6}
                                                                            />
                                                                            <InputGroup.Text>
                                                                                <i className="bi bi-calendar3"></i>
                                                                            </InputGroup.Text>
                                                                              {formValidation['fromEffectiveDate']?.isValid === false && (
                                                                                    <div className="invalid-feedback d-block">
                                                                                        {formValidation['fromEffectiveDate']?.warningText}
                                                                                    </div>
                                                                                )} 
                                                                                {selectedAction === constant.policyActionConstant.NEW && (
                                                                                    <div className="form-text text-warning mt-1">
                                                                                        {constant.policyActionSummaryConstant.NewModalEffectiveDateWarning}
                                                                                    </div>
                                                                                )}                                                                              
                                                                        </InputGroup>

                                                 <InputGroup className={`mb-3 ${formValidation['toEffectiveDate']?.isValid === false ? 'is-invalid' : ''}`}>
                                                                            <InputGroup.Text>
                                                                                {labelconstant.PolicyActionLabels.EXPIRATION_DATE}
                                                                            </InputGroup.Text>
                                                                            <DatePicker
                                                                                dateFormatCalendar="LLLL yyyy"
                                                                                dropdownMode="scroll"
                                                                                selected={CommonUtility.datetimeToDateOnlyObject(newPolicyComponentData.toEffectiveDate)}                                                                                
                                                                                onChange={(date) => onEntityFieldChange('toEffectiveDate', date)}
                                                                                className={`form-control ${formValidation['toEffectiveDate']?.isValid === false ? 'is-invalid' : ''}`}
                                                                                isRequired={true}
                                                                                tabIndex={7}
                                                                            />
                                                                            <InputGroup.Text>
                                                                                <i className="bi bi-calendar3"></i>
                                                                            </InputGroup.Text>
                                                                             {formValidation['toEffectiveDate']?.isValid === false && (
                                                                                    <div className="invalid-feedback d-block">
                                                                                        {formValidation['toEffectiveDate']?.warningText}
                                                                                    </div>
                                                                                )}
                                                                        </InputGroup>
                 </Row>
                <Row>
                    <Column>
                                                                <Select
                                                                    id="typeOfBusiness"
                                                                    controlId="typeOfBusiness"
                                                                    className='mb-3'
                                                                    label={<>{labelconstant.PolicyActionLabels.BUSINESS_TYPE}<span className="text-danger ms-1">*</span></>}
                                                                    options={typeOfBusiness}                                                                    
                                                                    defaultSelected={typeOfBusiness.filter(option =>
                                                                          option.value === newPolicyComponentData.selectedTypeOfBusiness
                                                                      )}
                                                                    onChange={(values) => onEntityFieldChange('selectedTypeOfBusiness', values[0] as string)}                                                                  
                                                                    disabled={false}
                                                                    tabIndex={8}
                                                                    isInvalid={formValidation['typeOfBusiness']?.isValid == false}
                                                                    invalidWarning={formValidation['typeOfBusiness']?.warningText}
                                                                />
                    </Column>
                    <Column>
                       <Select
                                                                    id="transactionDD"
                                                                    controlId="transactionDD"
                                                                    className='mb-3'
                                                                    label={<>{labelconstant.PolicyActionLabels.TRANSACTION_TYPE}<span className="text-danger ms-1">*</span></>}
                                                                    options={transactionTypes}
                                                                    defaultSelected={transactionTypes.filter(option =>
                                                                          option.value === newPolicyComponentData.selectedTransactionType
                                                                      )}
                                                                    onChange={(values) => onEntityFieldChange('selectedTransactionType', values[0] as string)} 
                                                                    disabled={false}
                                                                    tabIndex={9}
                                                                    isInvalid={formValidation['transactionDD']?.isValid == false}
                                                                    invalidWarning={formValidation['transactionDD']?.warningText}
                                                                />
                    </Column>
                    <Column>
                        <FloatingLabel controlId="transactionDescriptionTxt" label={labelconstant.CustomerPolicyDetailLabels.TRANSACTION_DESCRIPTION}>
                            <Form.Control
                                type="text"
                                name="transactionDescription"
                                placeholder={labelconstant.CustomerPolicyDetailLabels.TRANSACTION_DESCRIPTION}
                                value={newPolicyComponentData.transactionDescription || ""}
                                onChange={(event) => onEntityFieldChange('transactionDescription', event.currentTarget.value)}
                                disabled={false}
                                maxLength={500}
                                tabIndex={10}
                            />
                        </FloatingLabel>
                    </Column>
                 </Row>
                 <Row>
                    <Column>
                                                                <Select
                                                                    id="issueStateDD"
                                                                    controlId="issueStateDD"
                                                                    className='mb-2'
                                                                    label={<>{labelconstant.PolicyActionLabels.ISSUE_STATE}<span className="text-danger ms-1">*</span></>}
                                                                    options={issueStates}
                                                                    defaultSelected={issueStates.filter(option =>
                                                                          option.value === newPolicyComponentData.selectedState
                                                                      )}
                                                                    onChange={(values) => onEntityFieldChange('selectedState', values[0] as string)} 
                                                                    disabled={false}
                                                                    tabIndex={11}
                                                                    isInvalid={formValidation['issueStateDD']?.isValid == false}
                                                                    invalidWarning={formValidation['issueStateDD']?.warningText}
                                                                />
                    </Column>                  
                   
                 </Row>
                </Column>
                 <Column style={{flex: '0 0 35%'}}>
                 <Row>
                     <h6 className='me-2 mb-3'>COMPANY</h6>
                 </Row>
                          <Row>
                             <Select
                                                                    id="sourceDD"
                                                                    controlId="sourceDD"
                                                                    className='mb-3'
                                                                    label={<>{labelconstant.PolicyActionLabels.SOURCE}<span className="text-danger ms-1">*</span></>}
                                                                    options={source}                                                                   
                                                                    defaultSelected={source?.filter(option =>
                                                                            option.value === newPolicyComponentData.selectedSource
                                                                        )}
                                                                    onChange={(values) => handleSourceTypeChange(values[0] as string)}
                                                                    disabled={false}
                                                                    tabIndex={12}
                                                                    isInvalid={formValidation['sourceDD']?.isValid == false}
                                                                    invalidWarning={formValidation['sourceDD']?.warningText}
                                                                />
                          </Row>
                            <Row>
                             <Select
                                                                    id="sourceIDDD"
                                                                    controlId="sourceIDDD"
                                                                    className='mb-3 mt-1'
                                                                    label={<>{labelconstant.PolicyActionLabels.SOURCEID}<span className="text-danger ms-1">*</span></>}
                                                                    options={sourceId}
                                                                    defaultSelected={sourceId.filter(option =>
                                                                          option.value === newPolicyComponentData.selectedSourceId
                                                                      )}
                                                                    onChange={(values) => onEntityFieldChange('selectedSourceId', values[0] as string)} 
                                                                   disabled={false}
                                                                    tabIndex={13}
                                                                    isInvalid={formValidation['sourceIDDD']?.isValid == false}
                                                                   invalidWarning={formValidation['sourceIDDD']?.warningText}
                                                                />
                          </Row>
                          <Row>
                            <Select
                                id='policyTypeId'
                                controlId="policyTypeId"
                                className='mb-3 mt-1'
                                label={<>{labelconstant.CustomerPolicyDetailLabels.POLICY_TYPE}<span className="text-danger ms-1">*</span></>}
                                options={policyTypeList}
                                defaultSelected={policyTypeList?.filter(({ value }) =>
                                    value === newPolicyComponentData?.selectedPolicyTypeId
                                )}
                                onChange={(values) => {
                                    onEntityFieldChange('selectedPolicyTypeId', values[0] as string)
                                }}
                                placeholder={constant.PLEASE_SELECT}
                                multiple={false}
                                disabled={false}
                                tabIndex={14}
                                showAsFloatingLabel={true}
                                isInvalid={formValidation['policyTypeId']?.isValid == false}
                                invalidWarning={formValidation['policyTypeId']?.warningText}
                            />
                        </Row>
                         
                        <Row>
                            <Select
                                id="companyId"
                                controlId="companyId"
                                className='mb-3 mt-1'
                                label={<>{labelconstant.PolicyActionLabels.PARENT_COMPANY}<span className="text-danger ms-1">*</span></>}
                                options={parentCompanyList}
                                defaultSelected={parentCompanyList.filter(option =>
                                    option.value === newPolicyComponentData.selectedCompanyId
                                )}
                                onChange={(values) => handleParentCompanyChange(values[0] as string)}
                                disabled={false}
                                tabIndex={15}
                                isInvalid={formValidation['companyId']?.isValid == false}
                                invalidWarning={formValidation['companyId']?.warningText}
                            />
                        </Row>
                        <Row>
                            <Select
                                id='writingCompanyId'
                                controlId="writingCompanyId"
                                className='mb-3 mt-1'
                                label={<>{labelconstant.CustomerPolicyDetailLabels.WRITING_COMPANY}<span className="text-danger ms-1">*</span></>}
                                options={filteredWritingCompanies}
                                defaultSelected={filteredWritingCompanies?.filter(({ value }) =>
                                    value === newPolicyComponentData?.selectedWritingCompanyId
                                )}
                                onChange={(values) => {
                                    handleWritingCompanyChange(values[0] as string)
                                }}
                                placeholder={constant.PLEASE_SELECT}
                                multiple={false}
                                disabled={false}
                                tabIndex={16}
                                showAsFloatingLabel={true}                                
                                isInvalid={formValidation['writingCompanyId']?.isValid == false}
                                invalidWarning={formValidation['writingCompanyId']?.warningText}
                            />
                        </Row>
                        <Row>
                            <Column>
                                <FloatingLabel
                                    controlId="fullTermPremium"
                                    className='mb-3 mt-1'
                                    label={<>{labelconstant.PolicyActionLabels.FULL_TERM_PREMIUM}<span className="text-danger ms-1">*</span></>}
                                >
                                    <Form.Control
                                        type="text"
                                        inputMode="decimal"
                                        name="fullTermPremium"
                                        placeholder={labelconstant.PolicyActionLabels.FULL_TERM_PREMIUM}
                                        value={newPolicyComponentData.fullTermPremium || ""}
                                        onChange={(event) => {
                                            const typedValue = event.currentTarget.value;
                                            if (CommonUtility.isValidDecimalWithNegativeUpto2Limit(typedValue)) {
                                                onEntityFieldChange('fullTermPremium', typedValue);
                                            }
                                        }}
                                        disabled={false}
                                        required={true}
                                        isInvalid={formValidation['fullTermPremium']?.isValid == false}
                                        tabIndex={17}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formValidation['fullTermPremium']?.warningText}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Column>
                        </Row> 
                                                                        
                </Column>

            </Row>
           
             <Row className="mt-4 justify-content-end">
                <Column lg={2} className="d-flex justify-content-end">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => 
                           onCloseModal()
                        }
                        tabIndex={18}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => handleSavePolicy(newPolicyComponentData)}
                        tabIndex={19}
                        ref={submitButtonRef}
                        onKeyDown={(e) => {
                            if (e.key == "Tab" && !e.shiftKey) {
                                insuredCheckboxRef.current?.focus();
                                e.preventDefault();
                            }
                        }}
                    >
                        Submit
                    </button>
                </Column>
            </Row>
        </Container>
        </>
    );
};

export default CustomerNewPolicy;